import styled from 'styled-components';
import { Icon as SemanticIcon } from 'semantic-ui-react';

const Container = styled.div``;

const Icon = styled(SemanticIcon)`
  &&& {
    color: yellow;
  }
`;

export {
  Container,
  Icon,
};
